module.exports = __webpack_public_path__ + "img/emoji_31.22d69483.png";